var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex items-center" }, [
    _c(
      "label",
      { staticClass: "block w-22 flex-shrink-0 mr-2", attrs: { for: _vm.id } },
      [
        _vm._v("\n    " + _vm._s(_vm.label) + " "),
        _c("span", { staticClass: "text-sm" }, [_vm._v("(m)")]),
      ]
    ),
    _vm._v(" "),
    _c("input", {
      staticClass:
        "block min-w-0 h-11 border px-4 transition-colors duration-200",
      class: { "border-red": _vm.error },
      attrs: {
        id: _vm.id,
        name: _vm.name,
        type: "text",
        "aria-invalid": _vm.error,
      },
      domProps: { value: _vm.value },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }